export const SITE_URL = "https://edit-all.kr";

export const SITE_INFO = {
	title: "에딧올",
	description:
		"설치도 가입도 없이 브라우저에서 바로 쓰는 무료 영상 편집기. 영상은 내 컴퓨터 밖으로 나가지 않습니다.",
	url: SITE_URL,
	openGraphImage: "/open-graph/default.jpg",
	twitterImage: "/open-graph/default.jpg",
	favicon: "/favicon.ico",
};

export const DEFAULT_LOGO_URL = "/logos/opencut/svg/logo.svg";

/** 이 배포본이 누구를 위한 것인지. 랜딩 문구에 씁니다. */
export const AUDIENCE = {
	name: "이천 청년 농부",
	operator: "주식회사 에프오에프",
	contactEmail: "info@frameofframe.com",
};

/** 원본 오픈소스 프로젝트 — MIT 라이선스 고지에 씁니다. 지우지 마세요. */
export const UPSTREAM = {
	name: "OpenCut",
	url: "https://github.com/OpenCut-app/opencut-classic",
	license: "MIT",
};
